import { render, staticRenderFns } from "./TradeCartPayment.vue?vue&type=template&id=367ec489&"
import script from "./TradeCartPayment.vue?vue&type=script&lang=js&"
export * from "./TradeCartPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports